import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  CoursePauseRequestPagination,
  COURSE_PAUSE_REQUEST_STATUSES,
  currentPageSelector,
  useFilteredCoursePauseRequests,
} from 'features/courseResume';
import CoursePausePendingRequestsTableHeader from '../CoursePausePendingRequestsTableHeader';
import CoursePausePendingRequestsTableRow from '../CoursePausePendingRequestsTableRow';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './CoursePausePendingRequestsTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function CoursePausePendingRequestsTable() {
  const { requestType } = useParams();
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useFilteredCoursePauseRequests({
      requestType,
      coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.pending,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load pending requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const pendingRequests = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <CoursePausePendingRequestsTableHeader />
          <TableBody className={styles.rows}>
            {pendingRequests?.map((request) => (
              <CoursePausePendingRequestsTableRow
                coursePauseRequest={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="pending-request-pagination" />
        <div
          id="pending-request-pagination"
          className={styles.pagination}
        >
          <CoursePauseRequestPagination
            pageCount={data.meta?.total}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No requests found!"
        message="No pending pause requests exist at the moment!"
      />
    );
  }
}

export default CoursePausePendingRequestsTable;
